module.exports = __webpack_public_path__ + "static/people_pop26-ba28dfc364f5a1cacdf06627f5248f07.png";